import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import { shopcart_module } from "./shopcart";
import { member_module } from "./member";
import { post } from "@/common/request";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    main_dialog: {
      status: false, //系統訊息顯示狀態
      content: "", //系統訊息內容
    },
    member_token: "", //會員token
    search_dialog: false, //搜尋商品視窗顯示狀態
    shop_cart_open: false, //購物車顯示狀態
    loading: 0, //Loading狀態，大於0則為讀取中，等於0則為讀取完畢
    common_column_data: null, //通用欄位資料
    carousel_data: null, //首頁輪播資料
    news_data: null, //最新消息資料
    news_category_data: null, //最新消息分類資料
    menu_category_data: null, //商品目錄資料
    category_data: null, //商品分類資料
    event_data: null, //獨立銷售頁資料
    add_on_product_data: null, //加購商品資料
    product_data: null, //商品資料
    product_page_data: null, //商品分頁資料
    zipcode_data: null, //縣市郵遞區號資料
    keyword_data: null, //關鍵字搜尋資料
    page_meta_data: null, //頁面SEO資料

    api_key_list: {
      carousels: "carousel_data",
      news_categories: "news_category_data",
      news_list: "news_data",
      news_page: "news_page_data",
      product_categories: "menu_category_data",
      product_menu: "category_data",
      product_list: "product_data",
      product_page: "product_page_data",
      theme_columns: "common_column_data",
      zipcode: "zipcode_data",
      page_meta: "page_meta_data",
      zip_code: "zipcode_data",
      event_page: "event_data",
      keywords: "keyword_data",
    },
  },
  mutations: {
    // 設定購物車顯示狀態
    SetShopCartStatus(state, action) {
      state.shop_cart_open = action;
    },
    // 設定Loading狀態
    SetLoading(state, action) {
      if (action == 1) {
        state.loading += 1;
      } else {
        state.loading > 0 ? (state.loading -= 1) : "";
      }
    },
    // 設定系統訊息內容與狀態
    SetDialog(state, { status, content }) {
      state.main_dialog.status = status;
      state.main_dialog.content = content;
    },
    // 設定搜尋商品視窗顯示狀態
    SetSearchDialog(state, status) {
      state.search_dialog = status;
    },
    // 依照對應的key設定State資料
    SetStateData(state, { key, val }) {
      state[key] = val;
    },
    SetPageData(state, data) {
      Object.keys(data).forEach((key) => {
        const currentKey = state.api_key_list[key];

        if (currentKey == "common_column_data" && state[currentKey] != null) {
          //合併元有資料
          state[currentKey] = state[currentKey].concat(data[key]);
          //去除重複資料
          state[currentKey] = Array.from(new Set(state[currentKey]));
        } else if (currentKey == "product_data") {
          // 檢查如果是加購商品則放入加購商品資料
          if(data[key][0]?.Type == "add-on"){
            state["add_on_product_data"] = data[key][0];
          }
          else{
            state[currentKey] = data[key][0];
          }
          // 呼叫 shopcart_module 內的 SetProductData 方法，更新商品資料
          this.commit(
            "shopcart_module/SetProductData",
            data[key][0]?.List ?? []
          );
        } else if (data[key] != null) {
          state[currentKey] = data[key];
        } else if (state[currentKey] != null && state[currentKey].data) {
          state[currentKey].data = [];
        } else if (
          ["product_page_data", "news_page_data", "event_data"].indexOf(
            currentKey
          ) != -1
        ) {
          state[currentKey] = null;
        } else {
          state[currentKey] = [];
        }
      });
    },
  },
  actions: {
    getBasePageData(state) {
      // apiKeyList
      let data = {};
      Object.keys(window.global_data).forEach((key) => {
        switch (key) {
          case "product_data":
            data[key] = window.global_data[key][0];
            break;
          default:
            data[key] = window.global_data[key];
            break;
        }
      });

      state.commit("SetPageData", data);
    },
    // 取得當前頁面資料
    getPageData({ commit }, params) {
      return new Promise((resolve, reject) => {
        post("/frontend/list", params)
          .then((response) => {
            commit("SetPageData", response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  modules: {
    shopcart_module: shopcart_module,
    member_module: member_module,
  },
  plugins: [
    createPersistedState({
      paths: ["shopcart_module.shopcart"],
    }),
  ],
});
